export const handleOnCollapse = (
  state: boolean,
  setState: (newState: boolean) => void,
  onCollapse: (isCollapsed: boolean) => void
) => {
  if (onCollapse) {
    onCollapse(!state);
  }
  setState(!state);
};

export default {
  handleOnCollapse
};
